import { useSelector } from 'react-redux';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import { resolveUom } from '../../../lib/packingListNormalize';

/** 그리드 UOM 셀 표시. 마스터 코드로 매핑된 값을 보여주고, 미인식 표기는 원문을 주황색으로 남긴다. */
export function UomCell({ value, uomAliases }) {
    const uomMaster = useSelector((s) => s.packingList.uomMaster);
    if (!value) return null;
    const code = resolveUom(value, uomMaster, uomAliases);
    if (code) {
        return (
            <Typography sx={{ fontSize: 11, px: 1 }}>
                {code}
                {code !== String(value).toUpperCase() && <span style={{ color: '#7a7a7a' }}> ({value})</span>}
            </Typography>
        );
    }
    return <Typography sx={{ fontSize: 11, px: 1, color: 'warning.main', fontWeight: 600 }}>{value} ?</Typography>;
}

/**
 * UOM 편집 셀. 마스터 코드를 고르면 원문 표기가 그 코드의 별칭으로 쌓이고,
 * 마스터에 없는 단위를 직접 치면 그 표기 자체를 별칭으로 등록해 다음 PL부터 묻지 않는다.
 */
export default function UomSelect({ id, field, value, uomAliases, onAlias, maxLength }) {
    const apiRef = useGridApiContext();
    const uomMaster = useSelector((s) => s.packingList.uomMaster);
    const raw = value ?? '';
    const resolved = resolveUom(raw, uomMaster, uomAliases);
    const commit = (next) => {
        apiRef.current.setEditCellValue({ id, field, value: next });
        apiRef.current.stopCellEditMode({ id, field });
    };
    return (
        <Box sx={{ width: '100%', px: 0.5 }}>
            <Autocomplete
                size="small"
                freeSolo
                options={uomMaster}
                value={resolved ?? raw}
                openOnFocus
                autoHighlight
                onChange={(_, picked) => {
                    if (!picked) return commit(raw);
                    const code = String(picked).trim().toUpperCase();
                    if (raw && !resolved && code !== raw.toUpperCase()) onAlias(raw, code);
                    if (!uomMaster.includes(code)) onAlias(code, code);
                    commit(code);
                }}
                renderInput={(params) => <TextField {...params} inputProps={{ ...params.inputProps, maxLength }} autoFocus placeholder={raw && !resolved ? `${raw} → pick or type a UOM` : 'UOM'} sx={{ '& input': { fontSize: 11 } }} />}
                ListboxProps={{ style: { fontSize: 11 } }}
                slotProps={{ popper: { placement: 'bottom-start', style: { width: 'max-content', minWidth: 80 } } }}
                noOptionsText="Press Enter to register as a non-standard UOM"
            />
        </Box>
    );
}
